module.exports = ["#311B92","#512DA8","#673AB7","#9575CD","#D1C4E9"]


//////////////////
// WEBPACK FOOTER
// ./src/store/static/plot/AppPlotBaseColors.json
// module id = zvuN
// module chunks = 139